import React from 'react'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { IPostElementProps } from '../../../../../types/types'

const useStyles = makeStyles((theme: Theme) => ({
  commentsContainer: {
    display: 'flex',
    height: '36px',
    width: '100%',
    justifyContent: 'flex-end',
    borderRadius: '18px',
    backgroundColor: '#f0f2f5',
  },
  commentText: {
    padding: '8px 12px',
    flexBasis: 'auto',
    flexShrink: 1,
    flexGrow: 1,
  },
  iconsList: {
    display: 'flex',
    height: '36px',
    marginLeft: '-8px',
    marginRight: '4px',
    alignSelf: 'flex-end',
    alignItems: 'center',

    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  icons: {
    display: 'inline-block',
    alignSelf: 'center',
    height: '16px',
    width: '16px',
    backgroundImage: 'url(/src/shared/assets/images/preset.png)',
    backgroundSize: 'auto',
    backgroundRepeat: 'no-repeat',
    marginLeft: '6px',
    marginRight: '6px',
  },
  icon1: { backgroundPosition: '0 -455px' },
  icon2: { backgroundPosition: '0 -472px' },
  icon3: { backgroundPosition: '0 -523px' },
  icon4: { backgroundImage: 'url(/src/shared/assets/images/preset2.png)', backgroundPosition: '0 -50px' },
}))

const CommentsPreview: React.FC<IPostElementProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div style={{ padding: '8px 13px' }}>
      <div className={classes.commentsContainer}>
        <div className={classes.commentText}>{t('postCommon:commentPreview')}</div>
        <div>
          <ul className={classes.iconsList}>
            <li style={{ display: 'flex' }}><i className={`${classes.icons} ${classes.icon1}`} /></li>
            <li style={{ display: 'flex' }}><i className={`${classes.icons} ${classes.icon2}`} /></li>
            <li style={{ display: 'flex' }}><i className={`${classes.icons} ${classes.icon3}`} /></li>
            <li style={{ display: 'flex' }}><i className={`${classes.icons} ${classes.icon4}`} /></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CommentsPreview
